import React, {useState, useCallback, useEffect } from "react";
import { strings } from "./../../services/Localization";
// import AppContext from '../../context/AppContext'

import { useParams, useNavigate  } from 'react-router-dom';

import {notImplemented, /*DataTable, PageHeader, DetailPageContainer, , DataTableWrapper */} from '../../components/Common';

import { BreadCrumbType } from '../../datatypes/datatypes';

//import { Outlet  } from 'react-router-dom';

import PageContent from "../PageContent";

import {  PageButtonType } from '../../datatypes/datatypes';

import { faRefresh, faBoltAuto }  from '@fortawesome/pro-regular-svg-icons';

import { IUser } from "src/dassTypes";
import { ColumnType, DataTableOption } from "../../components/Common/DataTable/DataTypes";

import { TAB_DEVICE_INFO } from '../../datatypes/tabsconstants'

import { getAppBase, autoRefreshInterval } from "./../../utils/consts";

import{ DEFAULT_RECORD_LIMIT, DEVADDR_INPUT_VALIDATION }  from "../../components/Common/DataTable/DataTableConsts";
import { generateDateTimeColumn, generateDevEUIcolumn, generateGatewayColumn } from "../../components/Common/columnDefination";

interface IPageStates {
    loggedUser: IUser | null;
    showAlertModal: boolean;
    pageTitle: string;
    editEntityId: string | null;            // The entity in this view is a gateway
    schemaMethod: "post" |"put" | "" | string;
    breadCrumbArr: BreadCrumbType[];
    refresh:boolean;
    autoRefresh:boolean;
}

interface IPageProps {

}

export const pageTitle = strings.NAV_NST_DEVICES;
export const pageUrlPart = "omc-devices";

// export interface IRowType {

//     activated: boolean;             // true
//     altitude: number;               // null
//     appeui: string;                 // "0000000000000000"
//     applications: string;           // ""
//     comment: string;                // "vdev-p0-4-0-profile-otaa-1.0"
//     creation_time: string;          // "2021-11-30T13:42:51.767Z"
//     devaddr: string;                // "290396717"
//     deveui: string;                 // "6600000400000000"
//     device_profile_uuid: string;    // "1f5f1b18-166b-437f-8938-95bc28e94a2c"
//     device_status: number;          // 3
//     dl_fcnt: number;                // 8
//     groups: number;                 // ""
//     joineui: string;                // null
//     last_reception: string;         // "2021-12-02T08:57:15.587Z"
//     latitude: number;               // null
//     longitude: number;              // null
//     lora_device_class: number;      // 0
//     ownerid: string;                // "noise_robot_p0_4"
//     registration_status: number;    // 1
//     service_profile_uuid: string;   // "8c19a45d-4bc7-44b7-b123-935ff3041bc2"
//     suspended: boolean;             // null
//     tags: any;                      // null

//     ns_data: {
//         last_rx_time: string;
//         last_used_sf: string;
//         lastrssi: number;
//         lastsnr: number;
//         ma_nb_gws: number;
//         main_gtw_id: string;
//         main_gtw_name: string;
//     };
// }

interface IRowType {
    deveui: string;
    devaddr: string;
    last_used_sf: string;
    last_rx_time: string;   
    lastrssi: number;
    tenant_id: string;
    lastsnr: number;
    main_gtw_id: string;
    ma_nb_gws: number;
    main_gtw_name?:string
    description: string;

}

// function hex32(value: number) {
//     const hex = value.toString(16);
//     return "00000000".substring(hex.length) + hex;
// }



const OmcDevices: React.FC<IPageProps> = (props: IPageProps) =>  {

    let { id, tabname } = useParams();
    const navigate = useNavigate();


    // const AppContextObj = useContext(AppContext);

    const stateInit = {
        loggedUser: null,
        showAlertModal: false,
        pageTitle,
        editEntityId: '',
        schemaMethod: "",
        breadCrumbArr: [{label: pageTitle, url:''}],
        refresh:false,
        autoRefresh:false
    };

    const [state, setState] = useState<IPageStates>(stateInit)


    const detailPageNav = ( navigate, tab, id, row = null) => {

        if(id) {
            
            navigate(`${getAppBase()}/${pageUrlPart}/${id}/${tab}`, {state: {row: row, prevPageUrl: `${getAppBase()}/omc-devices`}})
        }else {

            notImplemented();

            
            navigate(`${getAppBase()}/${pageUrlPart}/${tab}`, {state: {tab: tab, prevPageUrl: `${getAppBase()}/omc-devices`}})
        }
    }

    const  getActions = () => {

        return {
            actions: [
            ],
            bulkActions:[
            ]
        }
    }

    useEffect(() => {
        
        const interval = setInterval(() => {
            if(state.autoRefresh) {
                refreshTable();
            }
        }, autoRefreshInterval);
        return () => clearInterval(interval);

    }, [state.autoRefresh]);

    const toggleAutoRefresh = () => {

        setState(prevState => { 
            return {...prevState, autoRefresh:!state.autoRefresh}
        })
    }

    const getPageButtons = useCallback(() => {
    
        const pageButtons:PageButtonType[] = [
            {
                title: strings.REFRESH_DEVICE_LIST,
                action: () => {  refreshTable() },
                type: 'button',
                icon: faRefresh
            },
            {
                title: (state.autoRefresh) ?  strings.STOP_AUTO_REFRESH : strings.AUTO_REFRESH,
                action: () => {  toggleAutoRefresh() },
                type: 'button_with_icon',
                varient: 'primary',
                icon: faBoltAuto
                
            }
        ]

        return pageButtons;
    },[state.autoRefresh]);

    const  initDataTable = () => {

        let pageButtons = getPageButtons();

        const actions = getActions();

		let columns: ColumnType[] = [
            generateDevEUIcolumn({
                key: "deveui",
                detailPageNav: (row: IRowType) => detailPageNav(navigate, TAB_DEVICE_INFO, row.deveui, row),
                filterField: "search_by_deveui"
            }),
            {
                key: "description",
                type: "text",
                title: strings.TABLE_NST_DEVICE_COMMENT,
                extraClass: 'ow-datatable-overflow-ellipsis',
                newCellWidth: "200px",
                render_tooltip:(row: IRowType) => row.description,  
                // filterable: true,
                // filterType: 'text',
                // inputValidation: ID_INPUT_VALIDATION,
                // filterField: 'search_comment',
                // filterSearchMinLength: 1,
                // filterParams: {
                //     mapper: (x) => x || undefined
                // },
                // sortable: true,
                // sortKey: "sort_by_comment",
                width: 100,
                minWidth: 100,
                flex: 2,
                resizable: true,
                showCopyLink: true
            },
            {
                key: "devaddr",
                title: strings.TABLE_NST_DEVADDR,
                type: "text",
                filterable: true,
                filterType: 'text',
                inputValidation: DEVADDR_INPUT_VALIDATION,
                filterField: 'search_by_devaddr',
                filterParams: {
                    mapper: (x) => x|| undefined
                },
                newCellWidth: "90px",
                sortable: true,
                sortKey: "sort_by_devaddr",
                cellWidth:15,
                // render: (row: IRowType) => row.devaddr ? hex32(parseInt(row.devaddr)) : "",

                detailLink: true,
                copyLink: true,
                detailPageNav: (row: IRowType) => detailPageNav(navigate, TAB_DEVICE_INFO, row.deveui, row),
                customClass: 'font-monospace nowarp',
                width: 110,
                minWidth: 110,
                maxWidth: 110,
                showCopyLink: true
            },

            {
                key: "tenant_name",
                type: "text",
                title: strings.TABLE_NST_TENANT,
                sortable: false,
                filterable: false,
                filterField: 'search_tenantName',
                filterType: 'text',
                
                
                // render: (row) => {
                //     if(row.tenant_id) {
                //         return String(row.tenant_id).substring(0,10) + '...';
                //     }else {
                //         return '';
                //     }
                    
                // },
                render_tooltip:(row) => {
                    return row.tenant_id;
                },
                cellWidth: 13,
                newCellWidth: "80px",
                width: 110,
                minWidth: 110,
                resizable: true,
                flex: 2,
                showCopyLink: true
            },
            {
                key: "last_used_sf",
                type: "text",
                title: strings.TABLE_NST_SPREADING_FACTOR,
                sortable: false,
                filterable: false,
                newCellWidth: "100px",
                render: (row: IRowType) => !row.last_used_sf ? "" : row.last_used_sf,
                width: 120,
                minWidth: 120,
                maxWidth: 120,
                showCopyLink: true
            },
            generateDateTimeColumn({
                key: "last_rx_time",
                title: strings.TABLE_NST_LAST_RECEPTION_TIME,
                sortable: true,
                sortKey: "sort_by_last_rx_time"
            }),
            {
                key: "lastrssi",
                type: "text",
                title: strings.TABLE_NST_LAST_RSSI,
                sortable: false,
                filterable: false,
                render: (row: IRowType) =>  !row.lastrssi ?  "" : row.lastrssi + "",
                dataAlign: 'center',
                newCellWidth: "70px",
                width: 70,
                minWidth: 70,
                maxWidth: 70,
            },
            {
                key: "lastsnr",
                type: "text",
                title: strings.TABLE_NST_LAST_SNR,
                sortable: false,
                filterable: false,
                render: (row: IRowType) => !row.lastsnr ? "" : Math.round(row.lastsnr) + "",
                dataAlign: 'center',
                newCellWidth: "70px",
                width: 70,
                minWidth: 70,
                maxWidth: 70,
            },
            generateGatewayColumn({
                 key: "main_gtw_id",
                title: strings.TABLE_NST_MAIN_GATEWAY_ID,
                sortable: false,
                filterable: false,
                detailPageNav: (row: IRowType) => detailPageNav(navigate, TAB_DEVICE_INFO, row.deveui, row),
            }),
            {
                key: "main_gtw_name",
                type: "text",
                newCellWidth: "150px",
                title: strings.TABLE_NST_MAIN_GATEWAY_NAME,
                sortable: false,
                filterable: false,
                render: (row: IRowType) => { 
                    let data = row?.main_gtw_name || "" 
                    return data; //String(data).substring(0,10) +  '...';
                },
                render_tooltip:(row: IRowType) => {
                    return row?.main_gtw_name || "";
                },
                extraClass: 'ellipsis-class',
                width: 100,
                minWidth: 100,
                flex: 2,
                resizable: true,
                hideDefaultTooltip: true,
                showCopyLink: true
            },
            {
                key: "ma_nb_gws",
                type: "text",
                title: strings.TABLE_NST_NUM_OF_GATEWAYS,
                sortable: false,
                filterable: false,
                newCellWidth: "60px",
                render: (row: IRowType) => Math.round(row.ma_nb_gws) + "" || "",
                dataAlign:'center',
                width: 80,
                minWidth: 80,
                maxWidth: 80,
            },
            
        ];

        // URL: https://cto-playground.dev.orbiwise.com:8443/omc/gateways?tags=&untagged=false&page=0&size=10&sort=name,asc&activated=true&projection=gatewayListView&sort=uuid,asc


        let options: DataTableOption<IRowType> = {
            url:'/uiapi/rest/omc/device_info/jsonnodelistview',
            query_param: {
                all: true,
                get_pages: true,
                limit: DEFAULT_RECORD_LIMIT,
                stream: 'progress',
            } as any,
            serial_number: false,
            defaultSortField: 'sort_by_last_rx_time',
            defaultSortOrder: 'asc',
            resizeWidth:[ 'description', 'main_gtw_name'],
            
            id_field:'deveui',
            oboe_path:'pages.*',
            available_key: 'deveui',
            emptyDataMsg: 'No OMC Device Available',
            columns,
            

        }


        return {
             ...actions
            , columns
            ,...options
            ,...pageButtons
        };
	}

    const refreshTable = () => {

        setState(prevState => {
            return {...prevState, refresh:!prevState.refresh}
        })

    }


    return (<PageContent
        name={`omc-devices`} 
        id={id} 
        tabname={tabname} 
        actions={getActions()} 
        breadCrumbArr={state.breadCrumbArr} 
        pageButtons={getPageButtons()} 
        countLabel={strings.NAV_NST_DEVICES} 
        dataTableOption={initDataTable()} 
        refresh={state.refresh}
        rowHeight="30px">
    </PageContent>)

}


export default OmcDevices;